import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchClient from "@dropDesk/presentation/components/inputs/select_search_clients";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputClientSearch = observer(
    ({
         setFilterClient,
         filterClient,
         loading,
         hideLabel,
         size
     }: {
        setFilterClient: (filter: ClientEntity | null, withList?: boolean) => void,
        filterClient: ClientEntity | null
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                {!appController.isUserClient &&
                    <Tooltip title={hideLabel ? 'Filtrar por empresa' : undefined}>
                        <div style={{display: "flex", flex: 1}}>
                            <SelectSearchClient
                                size={size ?? 40}
                                useRemoveFilter={!!filterClient}
                                label={hideLabel ? undefined : 'Filtrar por empresa'}
                                placeHolder={"Pesquise por empresa"}
                                handleSelectClient={(value, client) => {
                                    setFilterClient(client ?? null);
                                }}
                                value={filterClient ? {
                                    value: filterClient.id,
                                    label: !!filterClient.socialName ? filterClient.socialName : filterClient.name,
                                } : undefined}
                                disabled={loading}
                                iconLeftName={ICONS_DROPDESK.users}
                                borderColor={filterClient ? colors.accent : colors.border}
                            />
                        </div>
                    </Tooltip>
                }
            </>
        );
    })
export default InputClientSearch;
